import {
    FieldValidationResult, OldValidator,
    OldValidators
} from "@mintdata-wsp/wsp/ui/components/forms/validators/OldValidators";
import bind from "bind-decorator";

// -----------------------------------------------------------------------------

export class FullNameValidator
{
    private _validators;

    private _minLength = 2;
    private _maxLength = 64;

    constructor ()
    {
        this._validators = new OldValidators(
        [
            OldValidator.required(
                'Please enter your full name',
            ),
            // OldValidator.alphaNumericAndSpace(
            //     'Only alphabetic and numeric characters'
            // ),
            OldValidator.regexp(
                'Only alphabetic and numeric characters',
                {regexp: /^[a-zA-Z0-9 ]+$/}
            ),
            OldValidator.minLength( ({value, minLength}) =>
                `Please enter your full name more then ${minLength - 1} symbols | ( "${value}" is too short )`
            ),
            OldValidator.maxLength( ({value, maxLength}) =>
                `Please enter your full name less then ${maxLength + 1} symbols | ( "${value.substr(0, maxLength)}..." is too long )`
            ),
        ]);
    }

    @bind
    public isValidFn(value:string):FieldValidationResult
    {
        return this._validators.validate(value,
        {
            minLength: this._minLength,
            maxLength: this._maxLength,
        });
    }
}

// -----------------------------------------------------------------------------

export class PasswordValidator
{
    private _validators;

    private _props;

    constructor (props)
    {
        this._props = props;

        this._validators = new OldValidators(
        [
            OldValidator.required(
                'Please enter your password',
            ),
            OldValidator.minLength( ({value, minLength}) =>
                `Please enter your password more then ${minLength - 1} symbols | ( "${value.length}" is too short )`
            ),
            OldValidator.maxLength( ({value, maxLength}) =>
                `Please enter your password less then ${maxLength + 1} symbols | ( "${value.length}" is too long )`
            ),
            (value, {newPasswordField}) =>
            {
                setTimeout(() => {
                    if (newPasswordField && newPasswordField.elementRef && newPasswordField.elementRef.checkIsValid)
                        newPasswordField.elementRef.checkIsValid();
                }, 0);
                return FieldValidationResult.isValid();
            }
        ]);
    }

    @bind
    public isValidFn(value:string):FieldValidationResult
    {
        const form = this._props && this._props._form;
        return this._validators.validate(value,
        {
            newPasswordField: form && form.getField('newPassword'),
            ...this._props
        });
    }
}

// -----------------------------------------------------------------------------

export class NewPasswordValidator
{
    private _validators;

    private _props;

    constructor (props)
    {
        this._props = props;

        this._validators = new OldValidators(
        [
            // (new PasswordValidator({_form: this._form})).validators,
            OldValidator.required(
                'Please enter your new password',
            ),
            OldValidator.minLength( ({value, minLength}) =>
                `Please enter your new password more then ${minLength - 1} symbols | ( "${value.length}" is too short )`
            ),
            OldValidator.maxLength( ({value, maxLength}) =>
                `Please enter your new password less then ${maxLength + 1} symbols | ( "${value.length}" is too long )`
            ),
            (value, {password, retypePasswordField}) =>
            {
                setTimeout(() => {
                    if (retypePasswordField && retypePasswordField.elementRef && retypePasswordField.elementRef.checkIsValid)
                        retypePasswordField.elementRef.checkIsValid();
                }, 0);

                if (!password)
                    return FieldValidationResult.isValid();

                const isValid = value && password && value !== password;
                return isValid
                    ? FieldValidationResult.isValid()
                    : FieldValidationResult.isNotValid('You cannot repeat your current password');
            },
        ]);
    }

    @bind
    public isValidFn(value:string):FieldValidationResult
    {
        const form = this._props && this._props._form;
        return this._validators.validate(value,
        {
            password: form && form.get('password'),
            retypePasswordField: form && form.getField('retypePassword'),
            ...this._props
        });
    }
}

// -----------------------------------------------------------------------------

export class RetypePasswordValidator
{
    private _validators;

    private _props;

    constructor (props)
    {
        this._props = props;

        this._validators = new OldValidators(
        [
            // (new PasswordValidator({_form: this._form})).validators,
            OldValidator.required(
                'Please retype new password',
            ),
            OldValidator.minLength( ({value, minLength}) =>
                `Please retype new password more then ${minLength - 1} symbols | ( "${value.length}" is too short )`
            ),
            OldValidator.maxLength( ({value, maxLength}) =>
                `Please retype new password less then ${maxLength + 1} symbols | ( "${value.length}" is too long )`
            ),
            (value, {newPassword}) =>
            {
                const isValid = value && newPassword && value === newPassword;
                return isValid
                    ? FieldValidationResult.isValid()
                    : FieldValidationResult.isNotValid('Password does not match the new password.');
            },
        ]);
    }

    @bind
    public isValidFn(value:string):FieldValidationResult
    {
        const form = this._props && this._props._form;
        return this._validators.validate(value,
        {
            newPassword: form && form.get('newPassword'),
            ...this._props
        });
    }
}

// -----------------------------------------------------------------------------

export class EditProfileDialogValidators
{
    public fullName;
    public password;
    public newPassword;
    public retypePassword;

    private _validators = [];

    constructor(props:any = {})
    {
        props.minLength = 8;
        props.maxLength = 255;

        this._validators =
        [
            this.fullName       = new FullNameValidator().isValidFn,
            this.password       = new PasswordValidator(props).isValidFn,
            this.newPassword    = new NewPasswordValidator(props).isValidFn,
            this.retypePassword = new RetypePasswordValidator(props).isValidFn,
        ]
    }
}

// -----------------------------------------------------------------------------
